import React from 'react'
import PropTypes from 'prop-types'
import Toggle from 'material-ui/Toggle'

const FormSwitch = ({
  value,
  onChange,
  ...props,
}) => {
  return (
    <Toggle
      labelPosition="right"
      {...props}
      toggled={value}
      onToggle={(e, checked) => onChange(checked)}
    />
  )
}

FormSwitch.propTypes = {}
FormSwitch.defaultProps = {}

export default FormSwitch



// WEBPACK FOOTER //
// ./src/components/forms/bases/FormSwitch.js